const debitTypeConfig = {
  shouxin: 1,
  danjie: 2,
  xianxia: 3,
  qiyeqianbao: 4,
  zhifubaodaikou: 5,
  zhifubaodaifu: 6,
};

module.exports = {
  debitTypeConfig,
};
